<template>
  <TrainerLayout>
    <section class="my-10">
      <div class="mb-4">
        <div class="hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
          <select
            id="tabs"
            name="tabs"
            class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-light focus:border-green-light sm:text-sm rounded-md"
          >
            <option>Explore Music</option>

            <option selected>View Playlist</option>
          </select>
        </div>
        <div class="">
          <div class="flex justify-between flex-col md:flex-row">
            <nav class="border-b border-gray-200 -mb-px flex md:space-x-8 space-x-4" aria-label="Tabs">
              <!-- Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
              <router-link
                :to="{ name: 'music' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                Explore Music
              </router-link>

              <router-link
                :to="{ name: 'playlist' }"
                class="border-green-dark text-gray-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                :class="{ current: 'border-gray-dark text-gray-dark' }"
              >
                View Playlist
              </router-link>
              <router-link
                :to="{ name: 'favorite' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                Favorite
              </router-link>
            </nav>
            <button
              type="button"
              class="w-fit h-8 px-4 mt-4 md:mt-0 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-white ring-1 ring-green-light hover:text-green-light"
              @click="togglePlaylistModal"
              v-if="this.$route.params && !this.$route.params.cat"
            >
              Create New Playlists
            </button>
          </div>
          <Modal
            :title="'Create Playlist'"
            v-model="isMenuOpen"
            :classStr="'max-w-lg'"
          >
            <div class="mb-4 text-gray-700">
              <label class="block mb-1" for="">Create New Playlist</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 rounded-lg focus:shadow-outline ring-1 ring-gray-300"
                type="text"
                placeholder="Playlist Name"
                v-model="$v.playlist.$model"
                :class="{ 'ring-red-700': $v.playlist.$error }"
              />
              <div v-if="$v.playlist.$error">
                <span class="text-xs text-red-700" v-if="!$v.playlist.required">
                  Playlist Name field is required
                </span>
              </div>
            </div>
            <div class="mb-4 text-gray-700">
              <label class="block mb-1">Thumbnail Image</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 rounded-lg focus:shadow-outline ring-1 ring-gray-300"
                type="file"
                placeholder="Playlist Name"
                @change="onchangeThumbnail"
              />
            </div>
            <div class="flex items-center justify-end">
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
                @click="togglePlaylistModal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
                @click="onclickAdd"
              >
                Add New Playlist
              </button>
            </div>
          </Modal>
          <Modal
            :title="'Update Playlist'"
            v-model="isUpdatePlaylist"
            :classStr="'max-w-lg'"
          >
            <div class="mb-4 text-gray-700">
              <label class="block mb-1" for="">Update Playlist</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 rounded-lg focus:shadow-outline ring-1 ring-green-light"
                type="text"
                placeholder="Playlist Name"
                v-model="$v.updatePlaylist.$model"
                :class="{ 'ring-red-700': $v.updatePlaylist.$error }"
              />
              <div v-if="$v.updatePlaylist.$error">
                <span
                  class="text-xs text-red-700"
                  v-if="!$v.updatePlaylist.required"
                >
                  Playlist Name field is required
                </span>
              </div>
            </div>
            <div class="mb-4 text-gray-700">
              <label class="block mb-1">Thumbnail Image</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 rounded-lg focus:shadow-outline ring-1 ring-green-light"
                type="file"
                placeholder="Playlist Name"
                @change="onchangeThumbnail"
              />
            </div>
            <div class="mb-4 text-gray-700" v-if="thumbnailImagePreview">
              <img :src="thumbnailImagePreview" alt="" />
            </div>
            <div class="flex items-center justify-end">
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
                @click="toggleUpdatePlaylist"
              >
                Cancel
              </button>
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
                @click="onclickUpdate"
              >
                Update Playlist
              </button>
            </div>
          </Modal>
        </div>
      </div>

      <section
        class="mt-4 mb-4"
        v-if="this.$route.params && this.$route.params.cat"
      >
        <div class="">
          <div class="flex sm:items-center">
            <button type="button" @click="$router.go(-1)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <div class="flex-1">
              <h1 class="text-xl font-semibold text-gray-900 capitalize">
                {{
                  trainerPlaylistEdit &&
                  trainerPlaylistEdit[0] &&
                  trainerPlaylistEdit[0].name
                }}
              </h1>
            </div>
            <div class="space-x-2 flex items-center">
              <span
                class="ring-2 ring-green-light rounded-full p-1 flex items-center bg-green-light text-white hover:bg-white hover:text-green-light"
              >
                <button
                  type="button"
                  class="focus:outline-none"
                  @click="toggleUpdatePlaylist"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </button>
              </span>
              <span
                class="ring-2 ring-green-light rounded-full p-1 flex items-center bg-green-light text-white hover:bg-white hover:text-green-light"
              >
                <button
                  type="button"
                  class="focus:outline-none"
                  @click="onclickDelete"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </span>
            </div>
          </div>
          <div class="mt-8 flex flex-col">
            <div class="overflow-x-auto">
              <div
                class="inline-block min-w-full align-middle"
              >
                <div
                  class="overflow-hidden shadow ring-1 ring-white ring-opacity-5 md:rounded-lg"
                >
                  <table class="min-w-full divide-y divide-gray-300">
                    <div class="bg-gray-50 flex">
                        <div
                          scope="col"
                          class="py-3.5 ml-48 mr-96 text-left text-sm font-semibold text-gray-900"
                        >
                          Title
                        </div>
                        <div
                          scope="col"
                          class="py-3.5 ml-6 text-left text-sm font-semibold text-gray-900"
                        >
                          Duration
                        </div>
                        <div
                          scope="col"
                          class="ml-10 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Mood
                        </div>
                    </div>
                    <tbody
                      class="divide-y divide-gray-200 bg-white"
                      v-if="trainerPlaylistSong"
                    >
                      <draggable
                        v-model="trainerPlaylistSong"
                        group="people"
                        @start="drag = true"
                        :move="detectMove"
                        @end="drag = false"
                      >
                        <tr v-for="(t, i) in trainerPlaylistSong" :key="t.id">
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="2"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                              />
                            </svg>
                          </td>
                          <td
                            class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                          >
                            {{ i + 1 }}.
                          </td>
                          <td
                            class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6 relative"
                          >
                            <div class="flex items-center">
                              <div
                                class="h-12 w-12 flex-shrink-0 flex justify-center items-center"
                              >
                                <button
                                  class="absolute text-green-light focus:outline-none hidden play-icon action"
                                  title="Play"
                                  @click="onclickPlay(t && t.id)"
                                  :class="`play-${t && t.id}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25.5"
                                    height="25.5"
                                    viewBox="0 0 25.5 25.5"
                                  >
                                    <g
                                      id="Icon_feather-play-circle"
                                      data-name="Icon feather-play-circle"
                                      transform="translate(-2.25 -2.25)"
                                    >
                                      <path
                                        id="Path_2385"
                                        data-name="Path 2385"
                                        d="M27,15A12,12,0,1,1,15,3,12,12,0,0,1,27,15Z"
                                        transform="translate(0 0)"
                                        fill="#8dc73f"
                                        stroke="#8dc73f"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                      />
                                      <path
                                        id="Path_2386"
                                        data-name="Path 2386"
                                        d="M15,12l9,6-9,6Z"
                                        transform="translate(-3.429 -3)"
                                        fill="#fff"
                                        stroke="#fff"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                      />
                                    </g>
                                  </svg>
                                </button>
                                <button
                                  class="absolute text-green-light focus:outline-none hidden pause-icon"
                                  title="Pause"
                                  @click="onclickPause(t && t.id)"
                                  :class="`pause-${t && t.id}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-8 w-8"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </button>
                                <img
                                  class="h-12 w-12 rounded-md"
                                  :src="t.image"
                                  alt=""
                                  @error="defaultImage"
                                />
                              </div>
                              <div class="ml-4">
                                <div class="font-semibold text-gray-900">
                                  {{ t.name || "Music Name" }}
                                </div>
                                <div class="text-gray-dark">
                                  {{ t.artist || "Artist Name" }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                          >
                            <button
                              class="focus:outline-none"
                              @click="onclickWaveform(t && t.id)"
                            >
                              <av-waveform
                                :audio-class="`audio-${t && t.id}`"
                                :audio-src="t.url"
                                :canv-width="250"
                                :canv-height="30"
                                :audio-controls="false"
                                :playtime-with-ms="false"
                                :playtime-clickable="true"
                                :played-line-color="'#8dc73f'"
                                :noplayed-line-color="'#B5B5B5'"
                                :playtime-font-color="'#8dc73f'"
                                :playtime-slider-color="'#8dc73f'"
                              >
                              </av-waveform>
                            </button>
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                          >
                            <!-- <div class="text-gray-900">Front-end Developer</div> -->
                            <!-- <div class="text-gray-500">Optimization</div> -->
                            {{ formatSecond(t.duration || "0.00" / 60) }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                          >
                            {{
                              t.mood && t.mood.replace(/["]+/g, "").slice(1, -1)
                            }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                          >
                            <button class="hover:bg-green-light hover:text-white focus:outline-none"
                              type="button"
                              title="Remove"
                              @click="onclickRemove(t.song_id)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6 ring-2 ring-green-light rounded-md"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M20 12H4"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      </draggable>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mb-4" v-else>
        <!-- View Playlist -->
        <ul
          role="list"
          class="grid gap-8 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 3xl:grid-cols-6"
        >
          <li v-for="t in trainerPlaylist" :key="t.id">
            <router-link
              :to="{
                name: 'playlist',
                params: { cat: t.id },
              }"
            >
              <div class="space-y-2">
                <img
                  class="rounded-md duration-500 shadow-all"
                  :src="t.thumbnail_url"
                  alt=""
                  @error="defaultImage"
                />
                <div class="space-y-2">
                  <div class="text-md leading-6 font-medium space-y-1">
                    <h3 class="capitalize">{{ t.name }}</h3>
                    <router-link
                      :to="{ name: 'playlist' }"
                      class="text-gray-light text-sm hover:text-blue-500 hover:underline"
                    >
                      {{ t.count }} Songs
                    </router-link>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </section>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import { Modal } from "@/components/t-components";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions} from "vuex";
import draggable from "vuedraggable";

export default {
  name: "Playlist",
  components: {
    TrainerLayout,
    draggable,
    Modal,
  },
  data() {
    return {
      songs: [],
      audio: new Audio(require("@/assets/audio/tone.mp3")),
      isMenuOpen: false,
      isUpdatePlaylist: false,
      playlist: "",
      updatePlaylist: "",
      thumbnailImage: "",
      thumbnailImagePreview: "",
    };
  },
  validations: {
    playlist: {
      required,
    },
    updatePlaylist: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      "trainerPlaylist",
      "trainerPlaylistEdit",
      "trainerPlaylistSong",
    ]),
   
  },
  methods: {
    ...mapActions([
      "getTrainerPlaylist",
      "getTrainerPlaylistEdit",
      "postTrainerPlaylist",
      "deleteTrainerPlaylist",
      "updateTrainerPlaylist",
      "deleteTrainerPlaylistSong",
      "getTrainerPlaylistSong",
      "putTrainerPlaylistSong",
    ]),

    async detectMove(e) {
      const data = {
        id: this.$route.params && this.$route.params.cat,
        song_id: e.draggedContext.element.song_id,
        image: e.draggedContext.element.image,
        name: e.draggedContext.element.name,
        artist: e.draggedContext.element.artist,
        url: e.draggedContext.element.url,
        duration: e.draggedContext.element.duration,
        mood: e.draggedContext.element.mood,
        sort: e.draggedContext.futureIndex + 1,
      };
      await this.putTrainerPlaylistSong(data);
      await this.getTrainerPlaylistSong(this.$route.params && this.$route.params.cat);
    },

    onclickWaveform(id) {
      var play = document.getElementsByClassName(`play-${id}`)[0];
      var pause = document.getElementsByClassName(`pause-${id}`)[0];

      this.audio = document.getElementsByClassName(`audio-${id}`)[0];
      if (this.audio.paused) {
        var allAudios = document.querySelectorAll("audio");
        allAudios.forEach(function (audio) {
          audio.pause();
        });

        this.audio.play();
        play.style.display = "none";
        pause.style.display = "block";
        
      } else {
        this.audio.pause();
        play.style.display = "block";
        pause.style.display = "none";
      }
      return this.audio;
    },

    onclickPlay(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "none";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "block";

      var allAudios = document.querySelectorAll("audio");
      allAudios.forEach(function (audio) {
        audio.pause();
      });
      allAudios.forEach(function (audio) {
        audio.currentTime = 0;
        if (audio.className != `audio-${id}`) {
          audio.load();
          audio.currentTime = 0;
          audio.closest("tr").classList.remove("active");
        } else {
          audio.play();
          audio.closest("tr").classList.add("active");
        }
      });
    },

    onclickPause(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "block";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "none";

      var audio = document.getElementsByClassName(`audio-${id}`)[0];
      audio.pause();
    },

    formatSecond(val) {
      var date = new Date(0);
      date.setSeconds(val); // specify value for SECONDS here
      var timeString = date.toISOString().substr(11, 8);
      return timeString;
    },

    togglePlaylistModal() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    onclickAdd() {
      this.$v.playlist.$touch();
      if (this.$v.playlist.$invalid) {
        console.log("invalid");
      } else {
        let data = new FormData();
        data.append("name", this.playlist);
        data.append("thumbnail_image", this.thumbnailImage);
        this.postTrainerPlaylist(data);
        this.togglePlaylistModal();
      }
    },

    toggleUpdatePlaylist() {
      this.isUpdatePlaylist = !this.isUpdatePlaylist;
    },

    async onclickUpdate() {
      this.$v.updatePlaylist.$touch();
      if (this.$v.updatePlaylist.$invalid) {
        console.log("invalid");
      } else {
        let data = new FormData();
        data.append("id", this.$route.params && this.$route.params.cat);
        data.append("name", this.updatePlaylist);
        if (this.thumbnailImage) {
          data.append("thumbnail_image", this.thumbnailImage);
        }
        await this.updateTrainerPlaylist({
          id: this.$route.params && this.$route.params.cat,
          data,
        });
        this.$router.push({
          name: "playlist",
        });
      }
    },

    onchangeThumbnail(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var imageType = ["image/jpeg", "image/png"];
      var included = imageType.includes(files[0]["type"]);
      if (!included) {
        alert("File should be jpeg and png.");
        return;
      }

      this.thumbnailImage = files[0];
      this.createThumbnailImage(this.thumbnailImage);
    },

    createThumbnailImage(file) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnailImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async onclickRemove(song_id) {
      var c = confirm("Are you sure?");
      if (c) {
        const data = {
          id: this.$route.params && this.$route.params.cat,
          song_id: song_id,
        };
        await this.deleteTrainerPlaylistSong(data);
      }
    },

    onclickDelete() {
      var c = confirm("Are you sure?");
      if (c) {
        const data = {
          id: this.$route.params && this.$route.params.cat,
          name: "name",
        };
        this.deleteTrainerPlaylist(data);
        this.$router.push({
          name: "playlist",
        });
      }
    },

    // getName(id) {
    //   var obj =
    //     this.trainerPlaylist && this.trainerPlaylist.find((t) => t.id === id);
    //   return obj;
    // },
  },
  async created() {
    this.getTrainerPlaylist();
    if (this.$route.params && this.$route.params.cat) {
      this.getTrainerPlaylistSong(this.$route.params && this.$route.params.cat);
      await this.getTrainerPlaylistEdit(
        this.$route.params && this.$route.params.cat
      );
      this.updatePlaylist =
        this.trainerPlaylistEdit &&
        this.trainerPlaylistEdit[0] &&
        this.trainerPlaylistEdit[0].name;
      this.thumbnailImagePreview =
        this.trainerPlaylistEdit &&
        this.trainerPlaylistEdit[0] &&
        this.trainerPlaylistEdit[0].thumbnail_url;
    }
  },
  beforeDestroy() {
    this.$store.commit("setTrainerPlaylistSong", []);
    this.$store.commit("setTrainerPlaylistEdit", []);
  },
};
</script>

<style scoped>
.action {
  display: none;
}

tr:not(.active):hover .play-icon {
  display: inline !important;
}

tr:hover .action {
  display: inline;
}
</style>